import React from 'react';
import { useNavigate } from 'react-router-dom';
import useMediaQuery from '../useMediaQuery';
import logo from '../Vector Vault Icon.png';

const LoginForm = ({ form, handleChange, handleSubmit, loading, error }) => {
  const isMobile = useMediaQuery(768 * 2);
  const navigate = useNavigate();

  const handleRegisterClick = () => {
    navigate('/register');
  };

  const handleForgotPasswordClick = () => {
    navigate('/forgot-password');
  };

  // Wrapper function to lowercase email before submission
  const handleFormSubmit = (e) => {
    e.preventDefault();
    
    // Create a copy of the form with lowercased email
    const formWithLowercasedEmail = {
      ...form,
      email: form.email.toLowerCase()
    };
    
    // Call the parent's handleSubmit with the modified form
    handleSubmit(e, formWithLowercasedEmail);
  };

  return (
    <div style={{ 
      backgroundColor: '#080808', 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      padding: '40px 20px',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      color: '#ffffff',
    }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        marginBottom: '48px',
        marginTop: isMobile ? '20px' : '40px',
      }}>
        <img
          src={logo}
          alt="logo"
          style={{
            height: isMobile ? '3.5rem' : '4rem',
            marginRight: '12px',
          }}
        />
        <span style={{ 
          fontSize: isMobile ? '1.8rem' : '2.2rem', 
          fontWeight: '700', 
          letterSpacing: '-0.03em',
          color: '#ffffff',
        }}>
          Vector Vault
        </span>
      </div>

      <div style={{ 
        width: '100%', 
        maxWidth: '420px',
        backgroundColor: '#0d0d0d',
        border: '1px solid #1a1a1a',
        borderRadius: '16px',
        padding: '36px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
      }}>
        <h2 style={{ 
          textAlign: 'center', 
          marginBottom: '28px', 
          fontSize: '1.5rem',
          fontWeight: '700',
          letterSpacing: '-0.02em',
          color: '#ffffff',
        }}>Login</h2>
        
        <form onSubmit={handleFormSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '8px', 
              fontSize: '14px', 
              fontWeight: '500',
              color: '#999999',
            }}>Email</label>
            <input 
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Enter your email"
              style={{
                width: '100%',
                padding: '12px 14px',
                backgroundColor: '#111111',
                border: '1px solid #222222',
                borderRadius: '8px',
                color: '#ffffff',
                fontSize: '15px',
                fontFamily: "'Inter', sans-serif",
                outline: 'none',
                transition: 'border-color 0.2s',
                boxSizing: 'border-box',
              }}
              onFocus={(e) => e.target.style.borderColor = '#00d67a'}
              onBlur={(e) => e.target.style.borderColor = '#222222'}
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '8px', 
              fontSize: '14px', 
              fontWeight: '500',
              color: '#999999',
            }}>Password</label>
            <input 
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder="Enter your password"
              style={{
                width: '100%',
                padding: '12px 14px',
                backgroundColor: '#111111',
                border: '1px solid #222222',
                borderRadius: '8px',
                color: '#ffffff',
                fontSize: '15px',
                fontFamily: "'Inter', sans-serif",
                outline: 'none',
                transition: 'border-color 0.2s',
                boxSizing: 'border-box',
              }}
              onFocus={(e) => e.target.style.borderColor = '#00d67a'}
              onBlur={(e) => e.target.style.borderColor = '#222222'}
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: '#00d67a',
              color: '#000000',
              border: 'none',
              borderRadius: '8px',
              fontSize: '15px',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background-color 0.2s',
              fontFamily: "'Inter', sans-serif",
              opacity: loading ? 0.7 : 1,
            }}
            onMouseOver={(e) => !loading && (e.target.style.backgroundColor = '#00b368')}
            onMouseOut={(e) => !loading && (e.target.style.backgroundColor = '#00d67a')}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>

          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            marginTop: '20px',
          }}>
            <button
              type="button"
              onClick={handleRegisterClick}
              style={{
                background: 'none',
                border: 'none',
                color: '#00d67a',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                padding: 0,
                fontFamily: "'Inter', sans-serif",
              }}
            >
              Register
            </button>

            <button
              type="button"
              onClick={handleForgotPasswordClick}
              style={{
                background: 'none',
                border: 'none',
                color: '#666666',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                padding: 0,
                fontFamily: "'Inter', sans-serif",
              }}
            >
              Forgot Password?
            </button>
          </div>
        </form>

        {loading && (
          <div style={{ 
            marginTop: '16px', 
            padding: '10px 14px', 
            backgroundColor: 'rgba(0, 214, 122, 0.1)', 
            border: '1px solid rgba(0, 214, 122, 0.2)',
            borderRadius: '8px',
            color: '#00d67a',
            fontSize: '14px',
          }}>
            Loading...
          </div>
        )}
        {error && (
          <div style={{ 
            marginTop: '16px', 
            padding: '10px 14px', 
            backgroundColor: 'rgba(255, 68, 68, 0.1)', 
            border: '1px solid rgba(255, 68, 68, 0.2)',
            borderRadius: '8px',
            color: '#ff6b6b',
            fontSize: '14px',
          }}>
            An error occurred: {error}
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginForm;
